export const SvgSearch = () => (
  <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_996_3770)">
      <rect x="15" y="10" width="36" height="36" rx="18" fill="#97BAC7" />
      <path d="M34.7158 30.5714L36.8564 28.4308L34.7158 26.2902" stroke="white" strokeWidth="1.28571" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M36.6342 28.4306L29.1421 28.4306" stroke="white" strokeWidth="1.28571" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <filter id="filter0_d_996_3770" x="0.214286" y="0.357143" width="65.5714" height="65.5714" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="5.14286" />
        <feGaussianBlur stdDeviation="7.39286" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.254902 0 0 0 0 0.517647 0 0 0 0 0.968627 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_996_3770" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_996_3770" result="shape" />
      </filter>
    </defs>
  </svg>
);